<template>
        <div class="loginpage" >
            <div class="login-box" v-bind:class="{ changewidth: isActive }">
                <img src="../assets/images/login/logopaybay.png">
                <p class="login-title">修改密码</p>
                <div class="login-box-body">
            <el-form  :model="pwdForm" :rules="pwdrules" ref="pwdForm" class="demo-ruleForm">

                <el-form-item prop="username">
                    <el-input  v-model="pwdForm.username" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item prop="oldpassword">
                    <el-input type="password" v-model="pwdForm.oldpassword" placeholder="请输入原密码"></el-input>
                </el-form-item>

                <el-form-item prop="newpassword">
                    <el-input type="password" v-model="pwdForm.newpassword" placeholder="请输入新密码"></el-input>
                </el-form-item>

                <el-form-item prop="newpasswordr">
                    <el-input type="password" v-model="pwdForm.newpasswordr" placeholder="请再次输入新密码"></el-input>
                </el-form-item>

                <el-form-item class="form-group has-feedback submitlog">
                    <el-button type="primary"  @click="submitForm('pwdForm')">确定</el-button>
                    <el-button @click="resetForm('pwdForm')">取 消</el-button>
                    <router-link class="fb-touch" :to="{name:'login'}" style="margin-left: 10px;">返回登录</router-link>
                </el-form-item>
            </el-form>
                </div>
            </div>
        </div>
</template>
<script>
   import secret from '../assets/js/jsencrypt.min'
    var encrypt = new secret.JSEncrypt();
    export  default{
        data(){
            var validateCheckpass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入新密码！'));
                } else {
                    if (this.pwdForm.newpassword !== value) {
                        callback(new Error('两次输入密码不一致！'));
                    }
                    callback();
                }
            };
            return{
                screenWidth: document.body.clientWidth,
                isActive:true,
                url:this.requetHost+"/sys/user/changepwd",
                labelposition:"left",
                pwdForm:{
                    username:this.getcookie('username'),
                    newpassword:'',
                    newpasswordr:'',
                    oldpassword:''
                },
                pwdrules: {
                    newpassword: [
                        { required: true, message: '请输入新密码', trigger: 'blur' },
                        { validator: this.validatorSpace, trigger: 'blur' },
                        { validator: this.validatorCharmap, trigger: 'blur' },
                        { min: 0, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur' },
                    ],
                    newpasswordr: [
                        { required: true, message: '请再次输入新密码', trigger: 'blur' },
                        { validator: this.validatorSpace, trigger: 'blur' },
                        { validator: this.validatorCharmap, trigger: 'blur' },
                        { min: 0, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur' },
                        { validator: validateCheckpass, trigger: 'blur' }
                    ],
                    oldpassword: [
                        { required: true, message: '请输入原密码', trigger: 'blur' }
                    ]
                },

            }
        },
        created(){
        },methods:{
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                       // var encrypt =new this.$jsEncrypt.JSEncrypt();
                        var encrypt =new encrypt.JSEncrypt();
                        var oldpass ="";
                        var newpass ="";
                        encrypt.setPublicKey(this.publickey);
                        oldpass= encrypt.encrypt(this.pwdForm.oldpassword);
                        newpass= encrypt.encrypt(this.pwdForm.newpassword);
                        var params={username:this.pwdForm.username,newpassword:newpass,oldpassword:oldpass}
                        this.$http.post(this.url,params).then((response)=>{
                            var data=response.body;
                            debugger;
                            if(data.status=='200'){
                                this.$message({showClose: true,message: '保存成功',type: 'success'});
                                this.$router.push({name:"login"})
                            }else{
                                this.$message({showClose: true,message: '参数错误',type: 'error'});
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }

        }
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// ChangePwd.vue?8e7837d2